import React from "react";
import { useQuery } from "@apollo/client";

import DtsReactTable from "../../reuseableComponents/dtsReactTable/DtsReactTable";
import { GET_PUBLIC_TOTAL_COLIFORM_SAMPLE_HISTORY } from "../../../queries/archiveQrys/bacterialSummaryQueries";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const PublicTotalColiformSampleTable = (props) => {
  const { systemId, fromDate, toDate } = props;

  const ptcsColumns = [
    {
      Header: "",
      id: "monthColumn",
      columns: [
        {
          Header: "Month",
          accessor: "collectionDate",
          width: 70
        }
      ]
    },
    {
      Header: "Routine Sampling",
      id: "routineCol",
      columns: [
        {
          Header: "# of Samples Taken",
          id: "routineNoSamplesCol",
          accessor: "routineNoSample",
          width: 90
        },
        {
          Header: "TC+",
          id: "routineTcPosCol",
          accessor: (d) => {
            return d.routineTcPos > 0 ? <span style={{ color: "red" }}>{d.routineTcPos}</span> : d.routineTcPos;
          },
          width: 60
        },
        {
          Header: "Ecoli+",
          id: "routineEcoliPosCol",
          accessor: (d) => {
            return d.routineEcoliPos > 0 ? (
              <span style={{ color: "red" }}>{d.routineEcoliPos}</span>
            ) : (
              d.routineEcoliPos
            );
          },
          width: 70
        }
      ]
    },
    {
      Header: "Repeat Sampling",
      id: "repeatCol",
      columns: [
        {
          Header: "# of Samples Taken",
          id: "repeatNoSamplesCol",
          accessor: "repeatNoSample",
          width: 90
        },
        {
          Header: "TC+",
          id: "repeatTcPosCol",
          accessor: (d) => {
            return d.repeatTcPos > 0 ? <span style={{ color: "red" }}>{d.repeatTcPos}</span> : d.repeatTcPos;
          },
          width: 60
        },
        {
          Header: "Ecoli+",
          id: "repeatEcoliPosCol",
          accessor: (d) => {
            return d.repeatEcoliPos > 0 ? <span style={{ color: "red" }}>{d.repeatEcoliPos}</span> : d.repeatEcoliPos;
          },
          width: 70
        }
      ]
    },
    {
      Header: "Triggered Source Sampling",
      id: "triggeredCol",
      columns: [
        {
          Header: "# of Samples Taken",
          id: "triggeredNoSamplesCol",
          accessor: "triggeredNoSample",
          width: 90
        },
        {
          Header: "TC+",
          id: "triggeredTcPosCol",
          accessor: (d) => {
            return d.triggeredTcPos > 0 ? <span style={{ color: "red" }}>{d.triggeredTcPos}</span> : d.triggeredTcPos;
          },
          width: 60
        },
        {
          Header: "Ecoli+",
          id: "triggeredEcoliPosCol",
          accessor: (d) => {
            return d.triggeredEcoliPos > 0 ? (
              <span style={{ color: "red" }}>{d.triggeredEcoliPos}</span>
            ) : (
              d.triggeredEcoliPos
            );
          },
          width: 70
        }
      ]
    },
    {
      Header: () => {
        const header = (
          <p>
            Assessment Source Sampling
            <br />
            {otherSamplesReq} samples required each month
          </p>
        );
        return <div>{header}</div>;
      },
      id: "assessmentCol",
      columns: [
        {
          Header: "# of Samples Taken",
          id: "otherNoSamplesCol",
          accessor: "otherNoSample",
          width: 90
        },
        {
          Header: "TC+",
          id: "otherTcPosCol",
          accessor: (d) => {
            return d.otherTcPos > 0 ? <span style={{ color: "red" }}>{d.otherTcPos}</span> : d.otherTcPos;
          },
          width: 70
        },
        {
          Header: "Ecoli+",
          id: "otherEcoliPosCol",
          accessor: (d) => {
            return d.otherEcoliPos > 0 ? <span style={{ color: "red" }}>{d.otherEcoliPos}</span> : d.otherEcoliPos;
          },
          width: 70
        }
      ]
    }
  ];

  const { loading, error, data } = useQuery(GET_PUBLIC_TOTAL_COLIFORM_SAMPLE_HISTORY, {
    variables: { systemId, fromDate, toDate }
  });

  if (loading) return <SkeletonLoader width='100%' />;

  if (error) return <ErrorHandler error={error} />;

  let otherSamplesReq = 0;

  return (
    <>
      {data.getPublicTotalColiformSampleHistory.length > 0 ? (
        <>
          <DtsReactTable
            data={data.getPublicTotalColiformSampleHistory}
            columns={ptcsColumns}
            headerColor='ddw'
            cypressid='totalColiformTbl'
          />
          <p cypressid='lastSampleString'>{data.getTotalColiformLastSampleTakenInfo.value}</p>
        </>
      ) : (
        <span>No public total coliform sample history was found in the database.</span>
      )}
    </>
  );
};

export default PublicTotalColiformSampleTable;
